import React from 'react'
import {useCartContext} from '../../../context/CartContext';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import CCOHeadline from '../../fundamentals/CCOHeadline';
import {useTranslation} from 'react-i18next';
import {toCommaSeparatedDecimal} from "../../../utility/componentUtil";
import styles from "../../../common/constants/accessibility.module.css";

function P015CartSum() {
    const {t} = useTranslation();
    const {cartTotal, cartTotalDelivery} = useCartContext();
    return (
        <Grid
            container
            spacing={2}
            direction='row'
            sx={{
                margin: 0,
                maxWidth: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                bgcolor: 'var(--background-air-white)',

                p: {
                    xs: '16px 16px 16px 16px',
                    lg: '32px 32px 32px 32px',
                }
            }}>
            <Grid container size={{xs: 12}} tabIndex={0} className={styles.focusable}
                  aria-label={`${t('cart.sum')!} ${toCommaSeparatedDecimal(cartTotal)} €`}>
                <Grid
                    size={{xs: 6}}
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start'
                    }}>
                    {t('cart.sum')!}
                </Grid>
                <Grid
                    data-cypress={'cartSumAmount'}
                    size={{xs: 6}}
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                    {toCommaSeparatedDecimal(cartTotal)} €
                </Grid>
            </Grid>
            <Grid container size={{xs: 12}} tabIndex={0} className={styles.focusable}
                  aria-label={`${t('cart.shipping_fee_aria')!} ${cartTotal > 0 ? '2,00 €' :
                      '0,00 €'}`}>
                <Grid
                    size={{xs: 6}}
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start'
                    }}>
                    {t('cart.shipping_fee')!}
                </Grid>
                <Grid
                    size={{xs: 6}}
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                    {cartTotal > 0 ? '2,00 €' : '0,00 €'}
                </Grid>
            </Grid>
            <Grid size={{xs: 12}}>
                <Divider variant={'fullWidth'} flexItem orientation={'horizontal'}
                         sx={{marginY: 4}}/>
            </Grid>
            <Grid container size={{xs: 12}} tabIndex={0} className={styles.focusable}
                  aria-label={`${t('cart.total')!} ${toCommaSeparatedDecimal(
                      cartTotalDelivery)} €`}>
                <Grid
                    size={{xs: 6}}
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start'
                    }}>
                    <CCOHeadline type={'h6'} headline={t('cart.total')!}/>
                </Grid>
                <Grid
                    size={{xs: 6}}
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                    <CCOHeadline type={'h6'}
                                 headline={toCommaSeparatedDecimal(cartTotalDelivery) + ' €'}/>
                </Grid>
            </Grid>
            <Grid size={{xs: 12}} aria-label={t('cart.shipping_hint_aria')!} tabIndex={0}
                  className={styles.focusable}>
                {t('cart.shipping_hint')!}
            </Grid>
        </Grid>
    );
}

export default P015CartSum
